
































































































import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import UserInterface from "@/types/app/IUser";
import Endpoint from "@/utils/endpoint";
import BaseComponent from "@/utils/baseComponent";
import CustomerService from "@/services/customerService";

@Component({
    components: {
    },
})
export default class Dashboard extends BaseComponent {
    @Getter("getUser", { namespace: "auth" }) user!: UserInterface;

    customerService = new CustomerService(this.$http);
    private endpoint = new Endpoint();

    selected = [2];
    items = [
        {
            action: '15 sec',
            headline: 'ON',
            subtitle: `I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
            title: 'Api Customer',
        },
        {
            action: '2 sec',
            headline: 'ON',
            subtitle: `Update in`,
            title: 'Api Investment',
        },
        {
            action: '6 sec',
            headline: 'ON',
            subtitle: 'Update in',
            title: 'Api Product',
        },
        {
            action: '12 hr',
            headline: 'ON',
            subtitle: 'Have any ideas about what we should get Heidi for her birthday?',
            title: 'Api Authentication',
        }
    ];

}
